/* eslint-disable camelcase */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Modal, Grid, Button, Typography } from "@material-ui/core";
import AgapeIcon from "../../../../common/icons/AgapeIcon";
import ShareBox from "./ShareBox";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 600,
    borderRadius: "15px",
    top: `${30}%`,
    left: `${35}%`,
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
      left: 0,
    },
  },
  top: {
    height: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    position: "relative",
  },
  title: {
    fontFamily: "Vazir-Bold",
    fontSize: "1.5rem",
  },
  closeIcon: {
    position: "absolute",
    left: "0",
  },
  content: {
    backgroundColor: "#f8f9fe",
  },
  cost: {
    fontSize: "2rem",
    fontFamily: "Vazir-Bold",
    color: "#009693",
  },
  CurrencyFormat: {
    fontFamily: "Vazir-Bold",
    fontSize: "1.2rem",
    backgroundColor: "#d8d8d8",
    padding: ".5rem 1rem",
    margin: "0 1rem",
    borderRadius: "2rem",
  },
  subBtn: {
    backgroundColor: "#009693",
    border: "none",
    borderRadius: "2rem",
    fontSize: "1.5rem",
    padding: ".5rem 2rem",
    color: "#fff",
    cursor: "pointer",
    fontFamily: "Vazir",
    margin: ".5rem",
  },
  exiBtn: {
    border: "1px solid #555",
    borderRadius: "2rem",
    fontSize: "1.5rem",
    padding: ".5rem 2rem",
    color: "#555",
    cursor: "pointer",
    fontFamily: "Vazir",
    margin: ".5rem",
  },
  btnBox: {
    backgroundColor: "#f8f9fe",
    width: "100%",
  },
  details: {
    fontFamily: "Vazir-Bold",
  },
  btnColumn: {
    backgroundColor: "#fff",
    width: "80%",
    margin: "0 auto",
    borderRadius: "1rem",
    [theme.breakpoints.down("md")]: {
      width: "96%",
    },
  },
}));

const SimpleModal = ({
  openModal,
  setOpenModal,
  closeHandler,
  link,
  slug,
  ...props
}) => {
  const classes = useStyles();

  const content = (
    <Grid
      item
      container
      direction="column"
      spacing={2}
      className={classes.btnColumn}
    >
      <ShareBox link={link} slug={slug} />
    </Grid>
  );

  return (
    <div>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.paper}>
          <Grid container direction="column" spacing={2}>
            <Grid item className={classes.top}>
              <Typography variant="body1" className={classes.title}>
                اشتراک گذاری
              </Typography>
              <Button className={classes.closeIcon} onClick={closeHandler}>
                <AgapeIcon icon="close" size="1rem" />
              </Button>
            </Grid>
            <Grid item container direction="column" className={classes.content}>
              <Grid item>{content}</Grid>
            </Grid>
          </Grid>
          <SimpleModal />
        </div>
      </Modal>
    </div>
  );
};

export default SimpleModal;
